<template>
    <ad-form v-if="offer"
                :allowed-image-types="allowedImageTypes"
                :max-file-size="maxFileSize"
                :offer="offer"
                :edit-mode="true"
                :save-handler="getHandleEditAd"
                :locale="locale"></ad-form>
</template>

<script>
import AdForm from "../AdForm";
import AdsApi from "../../services/AdsApi";

export default {
    name: 'EditAd',
    components: {AdForm},
    data() {
        return {
            offer: null
        };
    },
    props: [
        'locale',
        'allowedImageTypes',
        'maxFileSize',
        'offerId',
        'csrfToken'
    ],
    created() {
        console.log(this.offerId);
        AdsApi.getShallowAdData(this.locale, this.offerId).then((response) => {
            this.offer = response.data;
        });
    },
    methods: {
        getHandleEditAd(offerData) {
            return AdsApi.editAd(offerData, this.locale, this.csrfToken).then(response => {
                return response.json();
            });
        }
    }
};
</script>

<style scoped>
</style>
